import { render } from "./PollQuestion.vue?vue&type=template&id=f2d8d444"
import script from "./PollQuestion.vue?vue&type=script&lang=js"
export * from "./PollQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__